var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4908 12.5131H25.5242V12.4633H14.7241V17.2633H21.506C20.5166 20.0575 17.858 22.0633 14.7241 22.0633C10.7479 22.0633 7.52413 18.8395 7.52413 14.8633C7.52413 10.8871 10.7479 7.66328 14.7241 7.66328C16.5596 7.66328 18.2294 8.35568 19.5008 9.48668L22.895 6.09248C20.7518 4.09508 17.885 2.86328 14.7241 2.86328C8.09713 2.86328 2.72412 8.23628 2.72412 14.8633C2.72412 21.4903 8.09713 26.8633 14.7241 26.8633C21.3512 26.8633 26.7242 21.4903 26.7242 14.8633C26.7242 14.0587 26.6414 13.2733 26.4908 12.5131Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1084 9.27788L8.05101 12.1693C9.11781 9.52808 11.7014 7.66328 14.7248 7.66328C16.5602 7.66328 18.23 8.35568 19.5014 9.48668L22.8956 6.09248C20.7524 4.09508 17.8856 2.86328 14.7248 2.86328C10.1156 2.86328 6.1184 5.46548 4.1084 9.27788Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7245 26.8606C17.8241 26.8606 20.6405 25.6744 22.7699 23.7454L19.0559 20.6026C17.8511 21.5152 16.3535 22.0606 14.7245 22.0606C11.6033 22.0606 8.95312 20.0704 7.95471 17.293L4.0415 20.308C6.02751 24.1942 10.0607 26.8606 14.7245 26.8606Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4907 12.5107H25.5241V12.4609H14.7241V17.2609H21.5059C21.0307 18.6031 20.1673 19.7605 19.0537 20.6035L19.0555 20.6023L22.7695 23.7451C22.5067 23.9839 26.7241 20.8609 26.7241 14.8609C26.7241 14.0563 26.6413 13.2709 26.4907 12.5107Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.910315423aeaa5f2b26564a7fa1b7ce3.svg";
export { ForwardRef as ReactComponent };